export default {
  apple_store: {
    caption: 'Download on the',
    value: 'Apple store',
    icon: 'apple_store_fill1',
    href: 'https://apps.apple.com/us/app/id1222861799',
  },
  google_play: {
    caption: 'Get it on',
    value: 'Google Play',
    icon: 'google_play_fill1',
    href: 'https://play.google.com/store/apps/details?id=com.admiralmarkets.android',
  },
  appgallery: {
    caption: 'Explore it on',
    value: 'AppGallery',
    icon: 'appgallery_fill1',
    href: 'https://appgallery.huawei.com/#/app/C104123159',
  },
};
